import { endpoints } from "../config";
import { deleteData, getData, postData, putData } from "./api-utils";

const getSession = () => getData(endpoints.unlimSession);
const postSession = (userId, deviceName, code) =>
  postData(endpoints.unlimSession, {
    user_id: userId,
    device_name: deviceName,
    code,
  });

const updateSession = (deviceName, id) =>
  putData(endpoints.unlimSession, { id, device_name: deviceName });

const deleteSession = (session_id) =>
  deleteData(endpoints.unlimSession + "/" + session_id);

export { getSession, postSession, updateSession, deleteSession };
